import React from "react";
import BasePage from "../base/BasePage";
import NavBar1 from "../components/Navbar1";
import HRISPresenter from "./HRISPresenter";
import HeroHrisSection from "./components/HeroHrisSection";
import FooterSection from "./components/FooterSection";
import SystemFutureSection from "./components/SystemFutureSection";
import SystemCapabilitiesSection from "./components/SystemCapabilitiesSection";
import KeySystemModulesSection from "./components/KeySystemModulesSection";
import ComplianceSection from "./components/ComplianceSection";
import SystemDashboardSection from "./components/SystemDashboardSection";
import CTAHrisSection from "./components/CTAHrisSection";
import DemoRequestModal from "./components/DemoRequestModal";
import "./HRISPage.css";

class HRISPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new HRISPresenter();
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll(); // Run immediately on mount
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const elements = document.querySelectorAll(".compliance-section .col-md-4");
    const triggerBottom = window.innerHeight * 0.85;

    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < triggerBottom) {
        el.classList.add("reveal");
      }
    });
  }

  render() {
    const heroContent = this.presenter.getHeroSectionContent();
    const overviewCards = this.presenter.getOverviewCards();
    const futureCards = this.presenter.getFutureCards();
    const capabilities = this.presenter.getSystemCapabilities();
    const modules = this.presenter.getKeySystemModules();
    const complianceItems = this.presenter.getComplianceItems();
    const footerText = this.presenter.getFooterContent().text;

    return (
      <>
        <NavBar1 className="shadow-sm" />

        <HeroHrisSection heroContent={heroContent} />

        <SystemFutureSection
          overviewCards={overviewCards}
          futureCards={futureCards}
        />

        <SystemCapabilitiesSection capabilities={capabilities} />

        <KeySystemModulesSection modules={modules} />

        <ComplianceSection complianceItems={complianceItems} />

<SystemDashboardSection dashboardImage={this.presenter.getDashboardImage()} />

        <CTAHrisSection />

        <FooterSection footerText={footerText} />

        <DemoRequestModal />
      </>
    );
  }
}

export default HRISPage;
